import React, { useState, useEffect } from 'react';
import {  useDispatch } from 'react-redux';
import {  invokeGetService } from "../../../store/global/actions";
import { routingRulesLabels } from '../../../config/common';
import Hyperlink from '../../atoms/links/Hyperlink';
import { constructIds, protocolTypes } from '../../../config/common';
import { Grid } from '@material-ui/core';



export default function ExpndedRoutingRule({ item, excludeAttributesList }) {
    const dispatch = useDispatch();
   
    const keys = Object.keys(item?.attributes);

    const [events, setEvents] = useState([]);
    const [clusterlets, setClusterlets] = useState([]);

    // const routingRuleDataOrder = {
    //     [protocolTypes.http]: { 'IN': ['name', 'dir', 'commandtype', 'op', 'code', 'parameters', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'commandtype', 'path', 'parameters', 'host', 'delegate'] },
    //     [protocolTypes.http2]: { 'IN': ['name', 'dir', 'commandtype', 'path', 'op', 'parameters', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'commandtype', 'path', 'parameters', 'host', 'delegate'] },
    //     [protocolTypes.mqtt]: { 'IN': ['name', 'dir', 'type', 'topic', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'commandcode', 'commandtype', 'delegate'] },
    //     [protocolTypes.diameter]: { 'IN': ['name', 'dir', 'commandcode', 'commandtype', 'vendorid', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'commandcode', 'commandtype', 'delegate'] },
    //     [protocolTypes.radius]: { 'IN': ['name', 'dir', 'commandcode', 'commandtype', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'commandcode', 'commandtype', 'delegate'] },
    //     [protocolTypes.asn1]: { 'IN': ['name', 'dir', 'type', 'nastype', 'parameters', 'ttype', 'tcmd', 'tinstance', 'delegate'], 'OUT': ['name', 'dir', 'ttype', 'tcmd', 'delegate'] }
    // };

    useEffect(() => {
        dispatch(invokeGetService('getBlueprintConstructs', []))
            .then((response) => {
                if (response?.data) {
                    setClusterlets( response.data?.clusterlets ? response.data?.clusterlets : [] );
                    setEvents( response.data?.events ? response.data?.events : [] );
                }else{
                    console.error("Blueprint constructs not found")
                }


            }).catch(error => {
                console.error(error);
            })
    }, [])


    const filterRrdefAttributes = (keys) => {
        const filteredAttributes = keys?.filter(item  => !excludeAttributesList?.includes(item));
        return filteredAttributes?.sort() || []
    }


    const filteredParameters = item?.attributes?.parameters?.filter(obj => obj?.key !== '' && obj?.value !== '');

    return (

        <Grid container className='rrdef_expanded_container'>
            {
                filterRrdefAttributes(keys)?.map((key, index) => {
                    return  (
                        <Grid item xs={6} className={`rrdef_list_item rrdef_attribute_${key}`}>
                            <div className='attribute_label' >{`${routingRulesLabels.find(e => e.value == key)?.label}:`}</div>
                            <div className='attribute_value'>
                                {
                                    // key === 'tcmd' ? <Hyperlink id={item.attributes.tcmd} type={'event'} item={events.find(e => e._id == item.attributes.tcmd)} screen={'information_flow'}> {events.find(e => e._id === item.attributes.tcmd)?.name} </Hyperlink>
                                    key === 'tcmd' ? <Hyperlink id={item.attributes.tcmd} type={'event'} item={events.find(e => e._id == item.attributes.tcmd)} screen={'transaction'}> {events.find(e => e._id === item.attributes.tcmd)?.name} </Hyperlink>

                                        : key === 'commandtype' ? (item?.attributes.commandtype == 'req' ? 'Request' : 'Response')
                                            : key === 'ttype' ? <Hyperlink id={item.attributes.ttype} type={constructIds.find(element => element.id == clusterlets.find(e => e._id == item.attributes.ttype)?.type)?.type} > {clusterlets.find(e => e._id == item.attributes.ttype)?.name}</Hyperlink>
                                                : key === 'delegate' ? clusterlets.find(e => e._id == item.attributes?.delegate)?.name
                                                    : key === 'parameters' ? JSON.stringify(filteredParameters)
                                                        : item?.attributes[key] == "" ? "Not filled" 
                                                            : item?.attributes[key] 
                                }
                            </div>
                        </Grid>
                    )
                })
            }
        </Grid>

    );
}